<template>
    <div class="pt-4 px-3 mt-8">
        <div class="flex items-center justify-between mb-4">
            <span class="sec_header">Dispatch Information</span>
            <button class="flex items-center gap-1"><img src="../../../assets/images/arrow-up.svg" /> Collapse</button>
        </div>
        <div class="flex flex-wrap w-full justify-between">
            <div class="info_wrapper">
                <div class="shiper_item">
                    <b>SENDER INFORMATION</b>
                    <p class="text_name">Regina Smith</p>
                    <p class="text_phone">(+234) 803 341 8901</p>
                </div>
                <div class="shiper_item">
                    <p class="text_name">7b Montgomery Drive
                        Friend’s Coloney Estate
                        Lekki, Lagos State
                        Nigeria</p>
                </div>
            </div>

            <div class="info_wrapper">
                <div class="shiper_item">
                    <b>RECEPIENT INFORMATION</b>
                    <p class="text_name">Regina Smith</p>
                    <p class="text_phone">(+234) 803 341 8901</p>
                </div>
                <div class="shiper_item">
                    <p class="text_name">7 Nwodo Street
                        GRA
                        Enugu, Enugu State
                        Nigeria</p>
                </div>
            </div>

            <div class="info_wrapper">
                <div class="shiper_item">
                    <b>ORDER CHANNEL</b>
                    <p class="text_name">Cloudenly</p>
                </div>
                <div class="shiper_item">
                    <b>ORDER #</b>
                    <p class="text_name">MX001234</p>
                </div>
                <div class="shiper_item">
                    <b>INSURED VALUE</b>
                    <p class="text_name">N208,000</p>
                </div>
            </div>

            <div class="info_wrapper">
                <div class="shiper_item">
                    <b>SHIPPING COST</b>
                    <p class="text_name">N12,500</p>
                </div>
                <div class="shiper_item">
                    <b>PAYMENT STATUS</b>
                    <p class="text_name">Paid</p>
                </div>
                <div class="shiper_item">
                    <b>CARD</b>
                    <p class="text_name">**** **** **** 7865</p>
                </div>
            </div>
        </div>

        <div>
            <p class="text-lg mt-7 mb-2">Order Items</p>
            <table class="custom-table responsive-table border-collapse">
                <thead>
                    <tr class="shadow-md rounded-lg">
                        <th>Item</th>
                        <th>Quantity</th>
                        <th>Dimension (Cm)</th>
                        <th>Gross Weight(kg)</th>
                        <th>Total Cost(N)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="pack in (shipping.packagees || [])" :key="pack.id" class="shadow-md rounded-lg">
                        <td>{{ pack.description || "N/A" }}</td>
                        <td>{{ pack.quantity || "N/A" }}</td>
                        <td>{{ pack.length ? pack.length : "0" }}</td>
                        <td>{{ pack.estimatedWeight || "N/A" }}</td>
                        <td>{{ pack.itemValue || "N/A" }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeNames: "",
            shipping: {
                packagees: []
            }
        }
    },
    methods: {
        handleChange() {

        }
    },
}
</script>

<style lang="scss" scoped>
.shiper_item {
    @apply mb-5
}

.custom-table {
    margin: 0;
}

.text_phone {
    @apply text-red-400
}

.info_wrapper {
    @apply w-full sm:w-[48%] md:w-[24%]
}

.sec_header {
    @apply font-[500]
}
</style>